const accordionToggles = document.querySelectorAll('[data-accordion-toggle]')
const accordionIcons = document.querySelectorAll('[data-accordion-icon]')
const accordionInners = document.querySelectorAll('[data-accordion-inner]')

accordionToggles.forEach((toggle, index) => {
	toggle.addEventListener('click', e => {
		e.preventDefault();
		accordionInners[index].classList.toggle('accordion__content--active')
		accordionIcons[index].classList.toggle('accordion__icon--active')
	})
})

const updateHeight = () => {
	accordionInners.forEach(inner => {
		inner.style.setProperty('--innerHeight', `${inner.scrollHeight}px`)
	})
}

updateHeight()

window.addEventListener('resize', updateHeight, { passive: true })